import type { INavigationRoute } from '../../components/sidebar/NavigationRoutes'

export const servicesSetupMenuChildren: INavigationRoute[] = [
  {
    name: 'services',
    displayName: 'menu.servicesCatalog',
    gate: 'service',
    meta: {
      icon: 'miscellaneous_services',
    },
  },
]
